// reservationStatusTexts.tsx
import React from "react";
import styled from "styled-components";

/* ---------- Drop-in bold that always shows bolder ---------- */
export const Strong = styled.span`
  font-weight: bold !important; /* force heavy */
  font-variation-settings: "wght" 900; /* for variable fonts */
  font-synthesis-weight: none; /* avoid fake bold */
`;

/* ---------- Status groups (unchanged) ---------- */
export const cancelledStatuses = [
  "Cancelled_By_Customer",
  "Cancelled_By_Restaurant",
  "Cancelled",
];

export const cancelledDidNotAttendStatuses = [
  "Cancelled_By_Customer",
  "Cancelled_By_Restaurant",
  "Cancelled",
  "Did_Not_Attend",
];

export const acceptedStatuses = [
  "Accepted",
  "Accepted_Without_Table",
  "Accepted_With_Table",
  "Accepted_edit",
  "Rejected_edition",
  "Late",
  "waiting_list",
  "Awaiting_customer_reconfirmation",
  "Awaiting_customer_reconfirmation_after_message",
];

export const pendingStatuses = [
  "Pending_from_customer",
  "Pending_from_restaurant",
];

/* ---------- Abbreviation (unchanged) ---------- */
export function getReservationStatusAbreviationTranslation(status) {
  switch (status) {
    case "Accepted":
    case "Accepted_Without_Table":
    case "Accepted_With_Table":
      return <>Confirmada</>;

    case "Pending_from_customer":
    case "Awaiting_customer_reconfirmation":
    case "Awaiting_customer_reconfirmation_after_message":
      return <>Aguarda reconfirmação do cliente</>;

    case "Pending_from_restaurant":
      return <>Aguarda aceitação do restaurante</>;

    case "waiting_list_by_client":
    case "queue":
    case "in_front":
      return <>Na lista de espera</>;

    case "waiting_list":
      return <>Na fila à porta</>;

    case "Edited":
      return <>Alteração por aceitar</>;
    case "Accepted_edit":
      return <>Alteração aceite</>;
    case "Rejected_edition":
      return <>Alteração recusada</>;

    case "Late":
      return <>Atrasada</>;

    case "Attended":
      return <>Mesa ocupada</>;
    case "Left":
      return <>Mesa livre</>;

    case "Did_Not_Attend":
      return <>Não compareceu</>;

    case "Cancelled_By_Customer":
    case "Cancelled":
      return <>Cancelada</>;
    case "Cancelled_By_Restaurant":
    case "Rejected":
      return <>Recusada</>;

    default:
      return <>Null</>;
  }
}

/* ---------- Tooltip (restaurant) with <Strong> ---------- */
export function getReservationStatusTooltipTranslationForRestaurant(status) {
  switch (status) {
    case "Accepted":
    case "Accepted_Without_Table":
    case "Accepted_With_Table":
      return (
        <>
          <Strong>Reserva confirmada.</Strong>
          <br />
          <br />
          Aguardar chegada dos clientes.
        </>
      );

    case "Awaiting_customer_reconfirmation":
      return (
        <>
          <Strong>
            Será enviada automaticamente uma mensagem ao cliente, mais perto da
            data, com um pedido de reconfirmação.
          </Strong>
          <br />
          <br />
          <Strong>Mensagem ainda não enviada:</Strong> aguardar envio de
          mensagem.
        </>
      );

    case "Awaiting_customer_reconfirmation_after_message":
      return (
        <>
          <Strong>Mensagem enviada ao cliente</Strong> com um pedido de
          reconfirmação.
          <br />
          <br />
          Aguardar reconfirmação do cliente.
        </>
      );

    case "Pending_from_restaurant":
      return <>O restaurante deve aceitar ou recusar a reserva.</>;

    case "waiting_list_by_client":
    case "queue":
    case "in_front":
      return <></>;

    case "Edited":
      return <>O restaurante deve aceitar ou recusar a edição à reserva.</>;
    case "Edited_accept":
      return (
        <>
          O restaurante deve aceitar ou recusar a edição à reserva.
          <br />
          <br />
          <Strong>Atenção:</Strong> a edição será aceite e a reserva ficará
          <Strong> confirmada</Strong> ou a aguardar reconfirmação do cliente.
          <br />
        </>
      );
    case "Edited_reject":
      return (
        <>
          O restaurante deve aceitar ou recusar a edição à reserva.
          <br />
          <Strong>Atenção:</Strong> a edição será aceite e a reserva ficará
          <Strong> confirmada</Strong> ou a aguardar reconfirmação do cliente.
          <br />
        </>
      );

    case "Accepted_edit":
      return (
        <>
          <Strong>Atenção:</Strong> a edição será aceite e a reserva ficará
          <Strong> confirmada</Strong> ou a aguardar reconfirmação do cliente.
          <br />
          Se a reserva estava{" "}
          <Strong>a aguardar aceitação do restaurante</Strong>, ficará
          definitivamente <Strong>recusada</Strong>.
          <br />
          Se a reserva estava{" "}
          <Strong>confirmada ou a aguardar reconfirmação do cliente</Strong>:
          continuará no estado em que estava, mas sem a edição solicitada.
        </>
      );

    case "Rejected_edition":
      return <>Nota descritiva do estado respetivo</>;

    case "Late":
      return <>Já passa da hora marcada.</>;

    case "waiting_list":
      return <>Na fila à porta</>;

    case "Cancelled_By_Customer":
    case "Cancelled":
      return (
        <>
          Reserva cancelada por: <Strong>Cliente</Strong>
          <br />
        </>
      );

    case "Cancelled_By_Restaurant":
      return <>Reserva recusada pelo restaurante</>;

    case "Attended":
      return <>Refeição em curso.</>;

    case "Left":
      return <>Refeição concluída.</>;

    case "Did_Not_Attend":
      return <>A reserva não se concretizou.</>;

    default:
      return <></>;
  }
}

/* ---------- Client message (with titles) using <Strong> ---------- */
export function getReservationStatusTranslationClient(status) {
  switch (status) {
    case "Accepted":
    case "Accepted_Without_Table":
    case "Accepted_With_Table":
      return (
        <>
          <Strong>Confirmada</Strong>
          <br />
          <br />
          Aguardamos a tua chegada.
        </>
      );

    case "Awaiting_customer_reconfirmation":
      return (
        <>
          <Strong>Registada - necessário reconfirmares</Strong>
          <br />
          <br />
          A tua reserva foi registada mas ainda será necessária a tua
          reconfirmação.
          <br />
          Irás receber um pedido de reconfirmação, mais perto da data.
          <br />
          <br />
          <div style={{ textDecoration: "underline" }}>
            A reserva só ficará definitivamente confirmada depois de tu
            reconfirmares.
          </div>
        </>
      );

    case "Awaiting_customer_reconfirmation_after_message":
      return (
        <>
          <Strong>Registada - necessário reconfirmares</Strong>
          <br />
          <br />
          Por favor verifica se está tudo certo e confirma a tua reserva.
          <br />
          <br />
          Esta ação é necessária para a tua reserva ficar confirmada.
        </>
      );

    case "Pending_from_restaurant":
      return (
        <>
          <Strong>A aguardar aceitação do restaurante</Strong>
          <br />
          <br />A tua reserva foi registada mas ainda{" "}
          <div style={{ textDecoration: "underline" }}>
            é necessário que seja aceite pelo restaurante.
          </div>
          <br />
          <br />
          Irás receber uma mensagem assim que o restaurante aceitar ou recusar a
          tua reserva.
        </>
      );

    case "waiting_list_by_client":
    case "queue":
    case "in_front":
      return (
        <>
          <Strong>Na lista de espera</Strong>
          <br />
          <br />
        </>
      );

    case "Edited":
      return (
        <>
          <Strong>A aguardar aceitação da alteração</Strong>
          <br />
          <br />A alteração à tua reserva foi registada mas ainda{" "}
          <div style={{ textDecoration: "underline" }}>
            é necessário que seja aceite pelo restaurante.
          </div>
          <br />
          <br />
          Irás receber uma mensagem assim que o restaurante aceitar ou recusar a
          tua edição.
        </>
      );

    case "Accepted_edit":
      return (
        <>
          <Strong>Alteração aceite</Strong>
          <br />
          <br />
          Nota descritiva do estado respetivo
        </>
      );

    case "Rejected_edition":
      return (
        <>
          <Strong>Alteração recusada</Strong>
          <br />
          <br />
          Nota descritiva do estado respetivo
        </>
      );

    case "Late":
      return (
        <>
          <Strong>Atrasada</Strong>
          <br />
          <br />
          Já passa da hora marcada.
        </>
      );

    case "waiting_list":
      return (
        <>
          <Strong>Na fila à porta</Strong>
          <br />
          <br />
          Irás receber uma mensagem quando vagar uma mesa.
        </>
      );

    case "Cancelled_By_Customer":
    case "Cancelled":
      return (
        <>
          <Strong>Cancelada</Strong>
          <br />
          <br />
          A tua reserva foi cancelada pelo cliente.
          <br />
          <br />
          Se desejares, cria uma nova reserva.
        </>
      );

    case "Cancelled_By_Restaurant":
      return (
        <>
          <Strong>Recusada</Strong>
          <br />
          <br />
          Infelizmente a tua reserva não foi aceite pelo restaurante.
        </>
      );

    case "Attended":
      return (
        <>
          <Strong>Em curso</Strong>
          <br />
          <br />
          Bom apetite!
        </>
      );

    case "Left":
      return (
        <>
          <Strong>Finalizada</Strong>
          <br />
          <br />
          Obrigado pela tua visita!
        </>
      );

    case "Did_Not_Attend":
      return (
        <>
          <Strong>Não compareceu</Strong>
          <br />
          <br />
          A tua reserva não se concretizou.
          <br />
          <br />
          Da próxima vez que não puderes comparecer, por favor cancela a tua
          reserva com antecedência.
        </>
      );

    default:
      return (
        <>
          <Strong>Desconhecido</Strong>
          <br />
          <br />
        </>
      );
  }
}

/* ---------- Colors (unchanged) ---------- */
export function getReservationStatusColors(status) {
  switch (status) {
    case "Pending_from_customer":
    case "Pending_from_restaurant":
    case "Edited":
    case "Late":
    case "waiting_list":
    case "Awaiting_customer_reconfirmation":
    case "Awaiting_customer_reconfirmation_after_message":
      return "#ebab21";

    case "Accepted":
    case "Accepted_Without_Table":
    case "Accepted_With_Table":
    case "Accepted_edit":
    case "Rejected_edition":
    case "Attended":
      return "#4CAE4C";

    case "Did_Not_Attend":
    case "Cancelled_By_Customer":
    case "Cancelled":
    case "Cancelled_By_Restaurant":
      return "#D94B4B";

    default:
      return "Null";
  }
}
